import React from 'react';
import Layout from '../../shared/components/Layout';
import TermsOfUseMain from '../components/TermsOfUseMain';

const TermsOfUse = () => {
  return (
    <React.Fragment>
      <Layout>
        <TermsOfUseMain />
      </Layout>
    </React.Fragment>
  );
};

export default TermsOfUse;
